export const GET_FIREWALL_CONFIG = 'GET_FIREWALL_CONFIG'
export const GET_ALL_IPS_BLOCKED = 'GET_ALL_IPS_BLOCKED'
